import React from 'react';
import {Control, FieldValues} from 'react-hook-form';
import FormCheckbox from '../FormCheckbox';
import {Box, Typography} from '@mui/material';
import {SessionTypes} from '../../../enums';
import {useTranslation} from 'react-i18next';

export interface SessionTypeFilters {
  [SessionTypes.game]: boolean;
  [SessionTypes.practice]: boolean;
  [SessionTypes.skills]: boolean;
}

interface Props {
  control: Control<FieldValues>;
}

const SessionTypeFilter: React.FC<Props> = ({control}) => {
  const {t} = useTranslation();
  return (
    <Box sx={{mb: 2}}>
      <Typography variant="h4" sx={{mb: 2}}>
        {t('sessionFilter.sessionTypes')}
      </Typography>
      <Box>
        <FormCheckbox
          control={control as unknown as Control<FieldValues>}
          name={`sessionTypes.${SessionTypes.game}`}
          label={`${t('sessionFilter.game')}`}
        />
        <FormCheckbox
          control={control as unknown as Control<FieldValues>}
          name={`sessionTypes.${SessionTypes.practice}`}
          label={`${t('sessionFilter.practice')}`}
        />
        <FormCheckbox
          control={control as unknown as Control<FieldValues>}
          name={`sessionTypes.${SessionTypes.skills}`}
          label={`${t('sessionFilter.skills')}`}
        />
      </Box>
    </Box>
  );
};

export default SessionTypeFilter;
